import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={21.265}
      height={19.627}
      viewBox="0 0 21.265 19.627"
      {...props}
    >
      <path
        fill="#f6324b"
        d="M9.246.813L.194 17.332a1.554 1.554 0 001.385 2.295h18.109a1.557 1.557 0 001.385-2.295L12.016.813a1.587 1.587 0 00-2.77 0zm2.285 6.854l-.184 6.233H9.916l-.184-6.236zm-.9 9.629a.941.941 0 11.976-.94.95.95 0 01-.976.944z"
      />
    </svg>
  );
}

export default SvgComponent;
